import React, { useEffect, useState } from 'react';
import { DATE_PICKER_OPTIONS, trackMixpanelPageView } from 'helpers/post';
import classNames from 'classnames';
import InputOrFlatpickr from 'components/InputOrFlatpickr';
import HorizontalRule from 'components/HorizontalRule';
import moment from 'moment';
import { connect } from 'react-redux';

const TournamentProfile = ({ details, user, ...props }) => {
  const [errors, setErrors] = useState({
    tournamentStartDate: '',
    tournamentEndDate: '',
  });

  const onChange = (field, value) => {
    props.onDetailsChange(field, moment(`${value} 14:00`).format());
  };

  const setLocations = (value) => {
    props.onDetailsChange('locationsNo', Math.min(value, 50));
  };

  const addLocation = (num) => () => {
    const newLocations = Number(details.locationsNo || 0) + num;
    setLocations(newLocations < 1 ? 1 : newLocations);
  };

  useEffect(() => {
    if (!props.editMode) trackMixpanelPageView('create-event/profile/tournament', user);
  }, [props.editMode, user]);

  useEffect(() => {
    const start = moment(details.tournamentStartDate);
    const end = moment(details.tournamentEndDate);

    setErrors({
      tournamentEndDate:
        details.tournamentStartDate && start.isAfter(end, 'day')
          ? 'End date must be after start date'
          : '',
      tournamentStartDate:
        details.tournamentEndDate && start.isAfter(end, 'day')
          ? 'Start date must be before end date'
          : start.isBefore(moment(), 'day')
          ? 'Start Date must be in future'
          : '',
    });
  }, [details.tournamentStartDate, details.tournamentEndDate]);

  return (
    <div className="tournament-profile">
      <div className="row">
        <div className="col-sm-12">
          <label>How many locations are there?</label>
          <div className="input-group col-sm-4 p-0">
            <div className="input-group-append">
              <span
                type="button"
                onClick={addLocation(-1)}
                className="input-group-text  remove-border-r"
              >
                <i className="fas fa-minus"></i>
              </span>
            </div>
            <input
              type="number"
              name="locationsNo"
              value={details.locationsNo}
              onChange={(e) => setLocations(e.target.value)}
              className={`form-control text-center pl-4 gotham-bold-font`}
              placeholder="1"
              min={1}
              required
            />
            <div className="input-group-append">
              <span type="button" onClick={addLocation(1)} className="input-group-text">
                <i className="fas fa-plus"></i>
              </span>
            </div>
            <div className="invalid-feedback">Number of locations is required</div>
          </div>
        </div>
      </div>
      <HorizontalRule dashed />
      <label className="p-0 mt-0 mb-2 tournament-dates">Tournament Dates</label>
      <div className="row">
        <div className="col-sm-5">
          <label htmlFor="tournamentStartDate">Start Date</label>
          <div className="input-group">
            <InputOrFlatpickr
              name="tournamentStartDate"
              value={details.tournamentStartDate}
              options={DATE_PICKER_OPTIONS}
              type="datetime"
              onChange={(val) => onChange('tournamentStartDate', val)}
              className={classNames('form-control text-center nimbus-regular-font', {
                'is-invalid': !!errors['tournamentStartDate'],
              })}
            />
            <div className="input-group-append">
              <span
                className="input-group-text cursor-pointer"
                onClick={() => {
                  const input = document.querySelector(`input[name="tournamentStartDate"]`);
                  if (input) input.focus();
                }}
              >
                <i className="far fa-calendar-alt"></i>
              </span>
            </div>
            <div className="invalid-feedback">{errors['tournamentStartDate']}</div>
          </div>
        </div>
        <div className="col-sm-5">
          <label htmlFor="tournamentEndDate">End Date</label>
          <div className="input-group">
            <InputOrFlatpickr
              name="tournamentEndDate"
              value={details.tournamentEndDate}
              options={DATE_PICKER_OPTIONS}
              type="datetime"
              onChange={(val) => onChange('tournamentEndDate', val)}
              className={classNames('form-control text-center nimbus-regular-font', {
                'is-invalid': !!errors['tournamentEndDate'],
              })}
            />
            <div className="input-group-append">
              <span
                className="input-group-text cursor-pointer"
                onClick={() => {
                  const input = document.querySelector(`input[name="tournamentEndDate"]`);
                  if (input) input.focus();
                }}
              >
                <i className="far fa-calendar-alt"></i>
              </span>
            </div>
            <div className="invalid-feedback">{errors['tournamentEndDate']}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  details: state.post.details,
  user: state.session.currentUser,
});

export default connect(mapStateToProps)(TournamentProfile);
